import Style from "./style"

import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetExamPaymentList from "entity/exam/useGetExamPaymentList"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import TableLoading from "shared/ui/TableLoading";

const PaymentList = () => {

    const [paymentList, isLoading] = useGetExamPaymentList()

    const sizeList = ["short", "medium", "long", "long", "expand", "long", "short", "short"]
    const tableHeadList = ["IDX", "사용자 IDX", "이름", "닉네임", "연락처", "결제 날짜", "점수", "합격 여부"]

    return (
        <Style.Wrapper>

            <Search placeholder="연락처에 포함되는 글자로 검색" />

            <TableLoading isLoading={isLoading}>
                <TStyle.TableDiv>
                    <TStyle.TableInner>
                        <TStyle.TableRow $title>
                            {tableHeadList.map((elem, index) =>
                                <TStyle.Data key={index} $title $size={sizeList[index]}>{elem}</TStyle.Data>
                            )}
                        </TStyle.TableRow>
                        {paymentList?.data?.payment_list?.map((elem, index) =>
                            <TStyle.TableRow key={index} $odd={index % 2 === 1} >
                                <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                                <TStyle.Data $size={sizeList[1]}>{elem?.account_idx}</TStyle.Data>
                                <TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
                                <TStyle.Data $size={sizeList[3]}>{elem?.nickname}</TStyle.Data>
                                <TStyle.Data $size={sizeList[4]}>+{elem?.international_number} {elem?.contact}</TStyle.Data>
                                <TStyle.Data $size={sizeList[5]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                                <TStyle.Data $size={sizeList[6]}>{elem?.grade}</TStyle.Data>
                                <TStyle.Data $size={sizeList[7]}>{elem?.is_pass ? "합격" : ""}</TStyle.Data>
                            </TStyle.TableRow>
                        )}
                    </TStyle.TableInner>
                </TStyle.TableDiv>
            </TableLoading>

            <Pagenation maxPage={paymentList?.data?.max_page} />

        </Style.Wrapper>
    )
}

export default PaymentList